<script lang="ts">
	import SideRail from '$components/SideRail.svelte';
	import { page } from '$app/state';
	import Fa from 'svelte-fa';
	import SideNavBarStreamItem from './SideNavBarStreamItem.svelte';
	import SideNavBarSuperUserItem from './SideNavBarSuperUserItem.svelte';
	import SettingsNavTree from './SettingsNavTree.svelte';

	function pathSelectionAtLen(route: string | null, len: number) {
		if (route) {
			const pathParams = route.split('/').filter((x) => x);
			if (len >= 2 && pathParams.length === len && pathParams[0] === 'admin') {
				return pathParams[len - 1];
			}
		}
		return null;
	}

	import {
		faPodcast,
		faGlobe,
		faBan,
		faExclamationTriangle,
		faVolumeUp,
		faRectangleList,
		faTicket,
		faChartLine,
		faQuestionCircle
	} from '@fortawesome/free-solid-svg-icons';
	import type { User } from '$lib/shared/lib/types';
	interface Props {
		user: User | null;
		collapsed?: boolean;
	}

	let { user, collapsed = false }: Props = $props();
	let tag = $derived(page.params.tag!);
	let showStreamAdminButtons = $derived(tag != null);
	let showSuperUserButtons = $derived(user && user.superuser);
	let superuserPath = $derived(pathSelectionAtLen(page.route.id, 2));
	let adminPath = $derived(pathSelectionAtLen(page.route.id, 3));
</script>

<SideRail>
	{#snippet lead()}
		{#if showStreamAdminButtons}
			<SideNavBarStreamItem
				selectedPath={adminPath}
				{tag}
				{collapsed}
				title="Panel"
				path="panel"
				icon={faRectangleList}
			></SideNavBarStreamItem>
			<SettingsNavTree {tag} {collapsed} selectedPath={adminPath} />
			<SideNavBarStreamItem
				selectedPath={adminPath}
				{tag}
				{collapsed}
				title="Moderation"
				path="moderation"
				icon={faBan}
			></SideNavBarStreamItem>
		{/if}
	{/snippet}
	{#snippet trail()}
		{#if showSuperUserButtons}
			<SideNavBarSuperUserItem
				selectedPath={superuserPath}
				{collapsed}
				title="Stats"
				path="stats"
				icon={faChartLine}
			></SideNavBarSuperUserItem>
			<SideNavBarSuperUserItem
				selectedPath={superuserPath}
				{collapsed}
				title="Blacklist Hits"
				path="blacklist-hits"
				icon={faExclamationTriangle}
			></SideNavBarSuperUserItem>
			<SideNavBarSuperUserItem
				selectedPath={superuserPath}
				{collapsed}
				title="Invites"
				path="invites"
				icon={faTicket}
			></SideNavBarSuperUserItem>
			<SideNavBarSuperUserItem
				selectedPath={superuserPath}
				{collapsed}
				title="Speakers"
				path="speakers"
				icon={faVolumeUp}
			></SideNavBarSuperUserItem>
			<SideNavBarSuperUserItem
				selectedPath={superuserPath}
				{collapsed}
				title="Shows"
				path="streams"
				icon={faPodcast}
			></SideNavBarSuperUserItem>
			<SideNavBarSuperUserItem
				selectedPath={superuserPath}
				{collapsed}
				title="Global Settings"
				path="settings"
				icon={faGlobe}
			></SideNavBarSuperUserItem>
		{/if}
		<a
			href="https://help.supertip.gg"
			target="_blank"
			rel="noopener noreferrer"
			class="block px-3 py-1.5 transition-colors hover:text-primary-500 dark:hover:text-primary-500"
		>
			<div class="flex {collapsed ? 'justify-center' : 'space-x-4'}">
				<div class="mt-1 justify-center"><Fa icon={faQuestionCircle} /></div>
				{#if !collapsed}
					<div>Help</div>
				{/if}
			</div>
		</a>
	{/snippet}
</SideRail>
